import "firebase/firestore";
import "firebase/auth";
import firebase from "firebase/app";

export const firebaseConfig = {
  apiKey: "AIzaSyC6VmUrPsPznqV7X85k39MT_0vvsPiN9zo",
  authDomain: "girlhack2021.firebaseapp.com",
  projectId: "girlhack2021",
  storageBucket: "girlhack2021.appspot.com",
  messagingSenderId: "709894717649",
  appId: "1:709894717649:web:42b9973436583c3c2305f0",
  measurementId: "G-XEP76HQS74",
};

export default !firebase.apps.length
  ? firebase.initializeApp(firebaseConfig)
  : firebase.app();
